/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type CompanyUploadedDataPackageSlug
 * 
 * @export
 */
export type CompanyUploadedDataPackageSlug = string;

export function CompanyUploadedDataPackageSlugFromJSON(json: any): CompanyUploadedDataPackageSlug {
    return CompanyUploadedDataPackageSlugFromJSONTyped(json, false);
}

export function CompanyUploadedDataPackageSlugFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyUploadedDataPackageSlug {
    if (json == null) {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    return {} as any;
}

export function CompanyUploadedDataPackageSlugToJSON(json: any): any {
    return CompanyUploadedDataPackageSlugToJSONTyped(json, false);
}

export function CompanyUploadedDataPackageSlugToJSONTyped(value?: CompanyUploadedDataPackageSlug | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    return {};
}

